import React from "react";
import { IconColor } from "../interface/ColorInterface";

const ScreenIconSvg: React.FC<IconColor> = ({
  color,
  width,
  height,
  transform,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.939 13.861L10.804 13.753C10.7538 13.7189 10.6994 13.6917 10.642 13.672L10.48 13.6C10.334 13.5695 10.1828 13.5757 10.0398 13.6181C9.89688 13.6605 9.7667 13.7378 9.661 13.843C9.5815 13.9305 9.51758 14.0309 9.472 14.14C9.40389 14.304 9.38581 14.4844 9.42003 14.6587C9.45425 14.8329 9.53925 14.9931 9.66433 15.1192C9.7894 15.2452 9.94897 15.3314 10.1229 15.367C10.2969 15.4025 10.4775 15.3859 10.642 15.319C10.7495 15.2668 10.8495 15.2002 10.939 15.121C11.0639 14.9944 11.1485 14.8337 11.1821 14.6591C11.2158 14.4845 11.1969 14.3039 11.128 14.14C11.0831 14.0359 11.019 13.9413 10.939 13.861ZM13.9 1H6.7C5.98392 1 5.29716 1.28446 4.79081 1.79081C4.28446 2.29716 4 2.98392 4 3.7V16.3C4 17.0161 4.28446 17.7028 4.79081 18.2092C5.29716 18.7155 5.98392 19 6.7 19H13.9C14.6161 19 15.3028 18.7155 15.8092 18.2092C16.3155 17.7028 16.6 17.0161 16.6 16.3V3.7C16.6 2.98392 16.3155 2.29716 15.8092 1.79081C15.3028 1.28446 14.6161 1 13.9 1ZM14.8 16.3C14.8 16.5387 14.7052 16.7676 14.5364 16.9364C14.3676 17.1052 14.1387 17.2 13.9 17.2H6.7C6.46131 17.2 6.23239 17.1052 6.0636 16.9364C5.89482 16.7676 5.8 16.5387 5.8 16.3V3.7C5.8 3.46131 5.89482 3.23239 6.0636 3.0636C6.23239 2.89482 6.46131 2.8 6.7 2.8H13.9C14.1387 2.8 14.3676 2.89482 14.5364 3.0636C14.7052 3.23239 14.8 3.46131 14.8 3.7V16.3Z"
        fill={color || "#8B8B8B"}
      />
    </svg>
  );
};

export default ScreenIconSvg;
